// extracted by mini-css-extract-plugin
module.exports = {"zoneColumn":"styles_zoneColumn__gYLvQ","fillEmptySpace":"styles_fillEmptySpace__zo1Gb"};